import { ActivityLog } from '@models/ActivityLog'

export const ACTIVITY_LOG_PAGE_SIZE = 25

/**
 * Whether another page exists after `page`, which served `rowsOnPage` rows.
 *
 * For an entity's history the API does not count the whole history:
 * `totalRecords` only exceeds the rows served so far when another page exists,
 * so it must never be displayed as a total.
 */
export const hasMorePages = (
  page: number,
  rowsOnPage: number,
  totalRecords: number,
  pageSize: number = ACTIVITY_LOG_PAGE_SIZE
): boolean => (page - 1) * pageSize + rowsOnPage < totalRecords

/**
 * Appends `nextPage` to `loaded`, keeping order and skipping logs already
 * loaded: a log inserted between two loads shifts the offset window, so the new
 * page can repeat a row already shown.
 */
export const mergeLogPages = (
  loaded: ActivityLog[],
  nextPage: ActivityLog[]
): ActivityLog[] => {
  const seenIds = new Set(loaded.map((log) => log.id))
  return [...loaded, ...nextPage.filter((log) => !seenIds.has(log.id))]
}
